import { render, staticRenderFns } from "./repeatedquery.vue?vue&type=template&id=2ed4d33b&scoped=true"
import script from "./repeatedquery.vue?vue&type=script&lang=js"
export * from "./repeatedquery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed4d33b",
  null
  
)

export default component.exports